import { React, useState } from "react";
import PropTypes from "prop-types";
import { canPerformAction } from "../../../utils/UserAuth";
import { Button } from "@mui/material";
import ConfirmModal from "../../../components/ConfirmModal";
import { toast } from "react-toastify";
import Parse from "../../../api/ApiConfig"
import { useDispatch } from "react-redux";
import { setLoadingState } from "../../../redux/AppSlice";
import {  useNavigate, useParams } from "react-router";
// eslint-disable-next-line no-unused-vars
function ContentSidebar({ contentData, type }) {
	let { id } = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [modalText, setModalText] = useState("");
	const [confirmModal, setConfirmModal] = useState(false);
	// console.log(contentData)
	const handleStatus = (status) => {
		if (status === "approve") {
			updateEducationStatus("approve");
		} else {
			updateEducationStatus("unapprove");
		}
	};

	const setModal = (status) => {
		// console.log(id)
		setConfirmModal(true);
		if (status === "approve") {
			setModalText({
				header: "Approve Content",
				desc: "Are you sure you want to approve this content?",
				btnText: "Yes, Approve",
				status: "approve",
			});
		} else {
			setModalText({
				header: "Unapprove Content",
				desc: "Are you sure you want to unapprove this content?",
				btnText: "Yes, Unapprove",
				status: "unapprove",
			});
		}
	};

	const updateEducationStatus = async (status) => {
		dispatch(setLoadingState(true));
		try {
			let Education = Parse.Object.extend("Education");
			const EducationObject = new Education();
			EducationObject.id = id;
			EducationObject.save({
				approve: status === "approve" ? true : false,
			}).then(() => {
				dispatch(setLoadingState(false));
				navigate("/education");
				toast.success("Content status updated successfully!");
			});
		} catch (error) {
			console.log(error);
			dispatch(setLoadingState(false));
			toast.error("Error updating Content status!");
		}
	};

	return (
		<div className='LeftSection'>
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: modalText?.header,
						desc: modalText?.desc,
						btnText: modalText?.btnText,
					}}
					handleDeleteAction={() => handleStatus(modalText?.status)}
				/>
			)}
			<div className='productDetails'>
				<img
					src={contentData?.coverPhoto || "/images/placeholder_img.jpg"}
					alt='thumbnail'
				/>
				<h6>{contentData?.name || "--"}</h6>
				<p>{contentData?.totalDuration || "--"}</p>
			</div>
			{canPerformAction("edit", "products") &&
				(contentData?.approve ? (
					<Button onClick={() => setModal("unapprove")} variant='contained' className='updateButton' type='button'>
						Unapprove
					</Button>
				) : (
					<>
						<Button onClick={() => setModal("approve")} variant='contained' className='updateButton' type='button'>
							Approve content
						</Button>
					</>
				))}
		</div>
	);
}

// Props Validation
ContentSidebar.propTypes = {
	contentData: PropTypes.object,
	type: PropTypes.string,
};

export default ContentSidebar;
